module.exports = require("core-js/library/fn/parse-int");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs2/core-js/parse-int.js
// module id = 739
// module chunks = 0